import React from 'react'

const CustomTooltip = ({ active, payload }) => {   
    if (active && payload && payload.length) {
        const payload0= payload[0]!==undefined;
        const payload1= payload[1]!==undefined;
        const payload2= payload[2]!==undefined;
        const payload3= payload[3]!==undefined;
        var voice=0 ;
        var messaging=0;
        var data=0;
        var other = 0;
        for (var i = 0; i < payload.length; i++) {
            if (payload[i].name === 'Voice') {
                voice = parseFloat(payload[i].value);
            } else if (payload[i].name === 'Messaging') {
                messaging = parseFloat(payload[i].value);
            } else if (payload[i].name === 'Data') {
                data = parseFloat(payload[i].value);
            } else if (payload[i].name === 'Other') {
                other = parseFloat(payload[i].value);
            }
        }
      return (
        <div className="custom-tooltip">
          <table className="table">
             <tbody>
                {payload0 &&
                  <tr>
                     <td className="custom-voice-label">Voice</td>
                     <td>{payload[0].unit + ` ${(voice).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}`}</td>
                  </tr>
                }
                {payload1 &&
                  <tr>
                      <td className="custom-message-label">Message</td>
                      <td>{payload[0].unit + ` ${(messaging).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}`}</td>
                  </tr>
                 }

                {payload2 &&
                  <tr>
                      <td className="custom-data-label">Data</td>
                      <td>{payload[0].unit + ` ${(data).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}`}</td>
                  </tr>
                 }
                {payload3 &&
                  <tr>
                      <td className="custom-other-label">Other</td>
                      <td>{payload[0].unit + ` ${(other).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}`}</td>
                  </tr>
                }                                     
                <tr>
                    <td className="custom-total-label">Total</td>                     
                    <td className="custom-total-label">{payload[0].unit + ` ${(voice + messaging + data + other).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}`}</td>
                </tr>
              </tbody>
          </table>           
        </div>
      );
    }
  
    return null;
  };

  export default CustomTooltip;